module.exports = __webpack_public_path__ + "img/Image 335.907254eb.svg";